var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3334 14V12.6667M11.3334 12.6667C11.1566 12.6667 10.987 12.5964 10.862 12.4714C10.7369 12.3464 10.6667 12.1768 10.6667 12V11.3333C10.6667 10.9797 10.8072 10.6406 11.0572 10.3905C11.3073 10.1405 11.6464 10 12 10H13.3334C13.687 10 14.0261 10.1405 14.2762 10.3905C14.5262 10.6406 14.6667 10.9797 14.6667 11.3333V12C14.6667 12.1768 14.5965 12.3464 14.4714 12.4714C14.3464 12.5964 14.1769 12.6667 14 12.6667M11.3334 12.6667H14M14 12.6667V14M12.6667 10V4.33333C12.6667 3.71449 12.4209 3.121 11.9833 2.68342C11.5457 2.24583 10.9522 2 10.3334 2C9.71454 2 9.12104 2.24583 8.68346 2.68342C8.24587 3.121 8.00004 3.71449 8.00004 4.33333V11.6667C8.00004 12.2855 7.75421 12.879 7.31662 13.3166C6.87904 13.7542 6.28555 14 5.66671 14C5.04787 14 4.45438 13.7542 4.01679 13.3166C3.57921 12.879 3.33337 12.2855 3.33337 11.6667V6M4.66671 3.33333C4.84352 3.33333 5.01309 3.40357 5.13811 3.5286C5.26314 3.65362 5.33337 3.82319 5.33337 4V4.66667C5.33337 5.02029 5.1929 5.35943 4.94285 5.60948C4.6928 5.85952 4.35366 6 4.00004 6H2.66671C2.31309 6 1.97395 5.85952 1.7239 5.60948C1.47385 5.35943 1.33337 5.02029 1.33337 4.66667V4C1.33337 3.82319 1.40361 3.65362 1.52864 3.5286C1.65366 3.40357 1.82323 3.33333 2.00004 3.33333H4.66671ZM2.00004 3.33333V2M4.66671 3.33333V2",
    strokeWidth: 1.33,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#768391"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCable);
export default __webpack_public_path__ + "static/media/cable.3291c94508128da6521e7d2d00baa257.svg";
export { ForwardRef as ReactComponent };